import styled from 'styled-components';

export const ScoutTemplatesHeader = styled.div`
  height: 100px;

  > div {
    display: flex;
    width: 100%;
    padding: ${({ theme }) => theme.sizing.medium};
    border-bottom: ${({ theme }) =>
      `1px ${theme.colours.canvas.primary.main} solid`};
    justify-content: space-between;
    height: 50px;
    align-items: center;
  }
`;
ScoutTemplatesHeader.displayName = `ScoutTemplatesHeader`;

export const ScoutTemplateTitle = styled.div`
  position: relative;
  padding-left: ${({ $paddingLeft, $visible }) =>
    $visible ? $paddingLeft || '2rem' : $paddingLeft || '0'};
  transition: padding-left ${({ theme }) => theme.animation.duration.default};
  color: ${({ theme }) => theme.colours.ink.primary.main};
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${({ theme }) => theme.typography.headingSmall.fontSize};
  font-weight: ${({ theme }) => theme.typography.headingSmall.fontWeight};
  line-height: ${({ theme }) => theme.typography.headingLarge.lineHeight};
  width: 70%;
  float: left;
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: ${({ $opacity }) => $opacity || 1};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};

  > div:first-child {
    position: absolute;
    top: 3px;
    left: 0;
    color: ${({ theme }) => theme.colours.messaging.warning.main};
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transform: scale(${({ $visible }) => ($visible ? 1 : 0.8)});
    transition:
      opacity ${({ theme }) => theme.animation.duration.default} 0.1s,
      transform ${({ theme }) => theme.animation.duration.default} 0.1s;
  }

  @keyframes svgUp {
    from {
      transform: translateY(23px);
    }
    to {
      transform: translateY(3px);
    }
  }
  @keyframes svgDown {
    from {
      transform: translateY(3px);
    }
    to {
      transform: translateY(23px);
    }
  }
`;
ScoutTemplateTitle.displayName = 'ScoutTemplateTitle';

export const ScoutTemplateActionButtons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
`;
ScoutTemplateActionButtons.displayName = 'ScoutTemplateActionButtons';
